"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => {
  var _theme$palette;
  return {
    shippingAddress: {
      marginBottom: theme.spacing(4)
    },
    header: {
      alignItems: "flex-start",
      borderBottom: "1px solid ".concat((_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.grey) === null || _theme$palette === void 0 ? void 0 : _theme$palette[100]),
      display: "flex",
      justifyContent: "space-between"
    },
    headline: {
      fontSize: "1.25rem",
      fontWeight: theme.typography.fontWeightBold,
      paddingBottom: theme.spacing(2),
      textTransform: "uppercase"
    },
    editButton: {
      height: 32,
      position: "relative",
      right: -4,
      top: -4,
      width: 32
    },
    wrapper: {
      padding: theme.spacing(1.5, 0, 0)
    },
    title: {
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: theme.spacing(1)
    }
  };
});
var _default = exports.default = styles;